import React from 'react';
export function BonusSection() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const bonuses = [{
    id: 1,
    header: 'BONO #01',
    number: '01',
    title: '🩺 Guía Docente de Primeros Auxilios',
    description: 'Explica de forma clara y práctica cómo actuar ante emergencias escolares: desmayos, golpes, cortes o crisis nerviosas.',
    value: '$15.000',
    numberColor: '#D4A843',
    pillBg: 'bg-[#D4A843]',
    borderColor: 'border-[#D4A843]/30',
    hoverBorderColor: 'hover:border-[#D4A843]/60'
  }, {
    id: 2,
    header: 'BONO #02',
    number: '02',
    title: '📘 Guía Maestra de Planificación Anual',
    description: 'Incluye planificaciones listas, organizadas por temas y niveles.',
    value: '$12.000',
    numberColor: '#B8922E',
    pillBg: 'bg-[#B8922E]',
    borderColor: 'border-[#B8922E]/30',
    hoverBorderColor: 'hover:border-[#B8922E]/60'
  }, {
    id: 3,
    header: 'BONO #03',
    number: '03',
    title: '✨ Actividades para tus clases listas',
    description: 'Clases listas, 50 actividades listas para que pongas en práctica en el aula.',
    value: '$10.000',
    numberColor: '#9A7B24',
    pillBg: 'bg-[#9A7B24]',
    borderColor: 'border-[#9A7B24]/30',
    hoverBorderColor: 'hover:border-[#9A7B24]/60'
  }];
  return <section id="bonus" className="py-5 sm:py-10 bg-transparent relative border-t border-gray-800" data-id="element-42">
      <div className="max-w-4xl mx-auto px-3 sm:px-6 relative z-10" data-id="element-43">
        <div className="text-center mb-4 sm:mb-8" data-id="element-44">
          <h2 className="text-lg sm:text-3xl md:text-4xl font-black text-white mb-1.5 sm:mb-3 drop-shadow-lg" data-id="element-45">
            BONUS exclusivos incluidos con tu compra
          </h2>
          <p className="text-xs sm:text-base text-gray-300 max-w-md mx-auto mb-3 sm:mb-4" data-id="element-46">
            Para que tengas respaldo profesional, evaluaciones sólidas y
            herramientas listas para implementar, incluimos 3 bonus
            estratégicos:
          </p>
          <div className="inline-block bg-gradient-to-r from-[#D4A843] to-[#9A7B24] text-white font-black text-[11px] sm:text-base md:text-lg px-3 sm:px-5 py-1 sm:py-1.5 rounded-md shadow-[0_0_20px_rgba(212,168,67,0.5)] border-2 border-white/20" data-id="element-47">
            🎁 ¡GRATIS POR EL DÍA DE HOY!
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 sm:gap-4" data-id="element-48">
          {bonuses.map(bonus => <div key={bonus.id} className={`relative rounded-xl overflow-hidden bg-[#1a1512] border ${bonus.borderColor} ${bonus.hoverBorderColor} transition-all duration-300 p-3 sm:p-4`} data-id="element-49">
              <span className="absolute top-1 right-3 text-[60px] sm:text-[70px] font-black leading-none pointer-events-none select-none" style={{
            color: bonus.numberColor,
            opacity: 0.15
          }} data-id="element-50">
                {bonus.number}
              </span>
              <div className="relative z-10 mb-2 sm:mb-3" data-id="element-51">
                <span className={`${bonus.pillBg} text-white text-[10px] sm:text-xs font-bold px-2 py-0.5 rounded-full tracking-wide`} data-id="element-52">
                  {bonus.header}
                </span>
              </div>
              <h4 className="relative z-10 text-sm sm:text-lg font-bold text-white mb-1 sm:mb-1.5 leading-tight pr-10" data-id="element-53">
                {bonus.title}
              </h4>
              <p className="relative z-10 text-gray-400 text-[11px] sm:text-sm mb-2.5 sm:mb-3 leading-relaxed" data-id="element-54">
                {bonus.description}
              </p>
              <div className="relative z-10 flex items-center justify-between mt-auto" data-id="element-55">
                <span className="text-gray-500 text-[11px] sm:text-sm line-through decoration-red-500 decoration-2" data-id="element-56">
                  Valor {bonus.value}
                </span>
                <span className="bg-[#D4A843] text-white text-[11px] sm:text-sm font-bold px-3 py-0.5 rounded-md shadow-[0_0_10px_rgba(212,168,67,0.3)]" data-id="element-57">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="mt-4 sm:mt-8 text-center" data-id="element-58">
          <div className="inline-block bg-[#1a1512] border border-[#D4A843]/30 rounded-lg px-4 sm:px-8 py-3 sm:py-5 shadow-[0_0_30px_rgba(212,168,67,0.1)]" data-id="element-59">
            <p className="text-gray-400 text-[11px] sm:text-sm mb-0.5 font-medium" data-id="element-60">
              Valor total de los 3 bonus:
            </p>
            <p className="text-xl sm:text-3xl font-black text-gray-400 line-through decoration-red-500 decoration-[3px] mb-1.5" data-id="element-61">
              $37.000
            </p>
            <p className="text-sm sm:text-lg text-white font-bold mb-0.5" data-id="element-62">
              Hoy te los llevás por:
            </p>
            <p className="text-3xl sm:text-5xl font-black text-[#E8C547] drop-shadow-[0_0_20px_rgba(212,168,67,0.5)]" data-id="element-63">
              $0
            </p>
            <p className="text-[#E8C547] font-bold text-[10px] sm:text-sm mt-1.5" data-id="element-64">
              ✨ Incluidos GRATIS con tu compra de hoy ✨
            </p>
          </div>
        </div>
      </div>
    </section>;
}